var apiContextRoot = null;

switch(process.env.NODE_ENV) {
  case 'local':
    apiContextRoot = "http://localhost:8383/charts-api";
    break;
  case 'localDev':
    apiContextRoot = "http://localhost:8383/charts-api";
    break;
  case 'development':
    apiContextRoot = "https://staging-api.healthcheckfitness.com/charts-api";
    break;
  case 'production':
    apiContextRoot = "https://rgbtech-api.healthcheckfitness.com/charts-api";
    break;
  default:
    apiContextRoot = "http://localhost:8383/charts-api"
}

console.log("[CONFIG-INIT] Initialize ApiContextRoot: " + apiContextRoot + " by NODE_ENV: " + process.env.NODE_ENV);

export default {
  userInfoContextPath: apiContextRoot + "/user-info",

  // Token Authentication API service Request Path
  issueOtpContextPath: apiContextRoot + "/token/authenticate/issue/otp",
  otpAuthContextPath: apiContextRoot + "/token/authenticate/otp/",
  tokenAuthContextPath: apiContextRoot + "/token/authenticate/token/",

  // Project Info API service Request Path
  projectInfoStatusChartData: apiContextRoot + "/project-info/status/chart/data",

  // Project Completeness API service Request Path
  projectCompletenessTotal: apiContextRoot + "/project-info/completeness/chart/total",
  projectCompletenessChartData: apiContextRoot + "/project-info/completeness/chart/data",

  // Project Questionnaire Types API service Request Path
  questTypeChartData: apiContextRoot + "/project-info/quest-type/chart/data",

  // Project UnImport Data List API service Request Path
  projectUnImportList: apiContextRoot + "/project-user/un-import/data",
  projectUnImportMembers: apiContextRoot + "/project-user/un-import/members/",
  // Download UnImport/Imported ProjectUser API service Request Path
  projectUnImportDownloadXlsx: apiContextRoot + "/resource/project-user/un-import/xlsx/",
  projectImportedDownloadXlsx: apiContextRoot + "/resource/project-user/imported/xlsx/",
  // Import ProjectUser API service Request Path
  importProjectUser: apiContextRoot + "/resource/import/project-user",

  downloadSampleImportUser: apiContextRoot + "/quest/mgmt/project/import-sample",

  // Mgmt Project Related API service Request Path
  mgmtProjectEntities: apiContextRoot + "/quest/mgmt/project",
  mgmtSaveProjectEntity: apiContextRoot + "/quest/mgmt/project/save",
  mgmtDeleteProjectEntity: apiContextRoot + "/quest/mgmt/project/delete",
  mgmtQuestQrCode: apiContextRoot + "/quest/mgmt/project/quest-qr-code/",
  mgmtProjectQuestExport: apiContextRoot + "/quest/mgmt/project/export",
  mgmtSaveProjectI18nMessage: apiContextRoot + "/quest/mgmt/project/i18n",
  
  // Mgmt ProjectUser Related API service Request Path
  mgmtProjectUserEntities: apiContextRoot + "/quest/mgmt/project-user",
  mgmtSaveProjectUserEntity: apiContextRoot + "/quest/mgmt/project-user/save",
  mgmtDeleteProjectUserEntity: apiContextRoot + "/quest/mgmt/project-user/delete",

  // Mgmt ProjectQuest Related API service Request Path
  mgmtProjectQuestSummaries: apiContextRoot + "/quest/mgmt/project-quest",
  mgmtProjectQuestImportSummary: apiContextRoot + "/quest/mgmt/project-quest/import",
  mgmtProjectQuestUnImportSummary: apiContextRoot + "/quest/mgmt/project-quest/unImport",
  mgmtProjectQuestExportImportUserQuests: apiContextRoot + "/quest/mgmt/project-quest/export/import-user/quests",
  mgmtProjectQuestUserReviewUrl: apiContextRoot + "/quest/mgmt/project-quest/user/review/url",
  mgmtProjectQuestUserQuestType: apiContextRoot + "/quest/mgmt/project-quest/user/quest-types",
  mgmtProjectQuestUpdateUnImport: apiContextRoot + "/quest/mgmt/project-quest/update/unImport",
  mgmtProjectQuestDeleteUnImport: apiContextRoot + "/quest/mgmt/project-quest/delete/unImport",
  mgmtProjectQuestGetMovingProjects: apiContextRoot + "/quest/mgmt/project-quest/movingProjects",
  mgmtProjectQuestMoveUserQuestToProject: apiContextRoot + "/quest/mgmt/project-quest/move/userQuests",

  // Mgmt User Related API service Request Path
  mgmtUserEntity: apiContextRoot + "/quest/mgmt/user",
  mgmtUpdateUserCredential: apiContextRoot + "/quest/mgmt/user/credential"
};
